const getAssessmentTabsIndicatorObject = (theme) => {
  return {
    assessmentTabsIndicator: {
      width: "100%",
      padding: "10px 0px",
    },
    assessmentTabsIndicatorMobile: {
      width: "100%",
      marginTop: "84px",
      padding: "10px 10%",
      backgroundColor: "white",
      borderBottom: "1px solid #0304041a",
    },
  };
};

export const getAssessmentTabsIndicatorStyle = getAssessmentTabsIndicatorObject;
